module.exports = __webpack_public_path__ + "static/media/Jawbreak-Serif.42243a82.woff";